module.exports = __webpack_public_path__ + "img/mbBanner20.90ee12d9.png";